// extracted by mini-css-extract-plugin
module.exports = {"Root":"Link_Root__Mc9is"};